import { CategoryDataService } from './services/category-data.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { LoginComponent } from './modules/login/login.component';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { environment } from '../environments/environment';
import { CoreModule } from './core/core.module';
import { AuthGuard } from './core/auth.guard';
import { AdminGuard } from './core/admin.guard';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthService } from './core/auth.service';
import { ManageUserService } from './modules/manage-user/manage-user.service';
import { InvestorDetailsComponent } from './modules/investor-details/investor-details.component';
import { InvestorDataService } from './core/investor-data.service';
import { EditorGuard } from './core/editor.guard';
import { SuperAdminGuard } from './core/super-admin.guard';
import { ManageUserComponent } from './modules/manage-user/manage-user/manage-user.component';
import { AngularFireDatabase } from 'angularfire2/database';
import { EditUserComponent } from './modules/manage-user/edit-user/edit-user.component';
import { ExistingUserComponent } from './modules/manage-user/existing-user/existing-user.component';
import { ExistingUserInvestorsComponent } from './modules/manage-user/existing-user-investors/existing-user-investors.component';
import { ScorecardCalcService } from './services/scorecard-calc.service';
import { CalcService } from './services/calc.service';
import { AssetTabComponent } from './modules/hwcheckup/asset-details/asset-tab/asset-tab.component';
import { FinReportComponent } from './modules/hwcheckup/fin-report/fin-report.component';
import { InsuranceReportComponent } from './modules/hwcheckup/insurance-report/insurance-report.component';
import { HwcheckupModule } from './modules/hwcheckup/hwcheckup.module';
import { DropZoneDirective } from './directives/drop-zone.directive';
import { ManageComponent } from './modules/hwcheckup/reports/manage/manage.component';
import { FileSettingsComponent } from './modules/file-settings/file-settings.component';
import { AssetCatalogComponent } from './modules/asset-selection/asset-catalog/asset-catalog.component';
import { AssetService } from './services/asset.service';
import { RangeFilterPipe } from './modules/shared/pipes/range-filter.pipe';
import { ItemMatchingPipe } from './modules/shared/pipes/item-matching.pipe';
import { SharedModule } from './modules/shared/shared.module';
import { Ng5SliderModule } from 'ng5-slider';
import { AssetItemComponent } from './modules/asset-item/asset-item.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SuggestionReportComponent } from './modules/hwcheckup/suggestion-report/suggestion-report.component';
import { InvestorHistoryComponent } from './modules/history/investor-history/investor-history.component';
import { SuggestionHistoryComponent } from './modules/history/suggestion-history/suggestion-history.component';

const appRoutes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'home',
    loadChildren: './modules/home/home.module#HomeModule',
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    component: FileSettingsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'asset-catalog/:uid',
    component: AssetCatalogComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'risk-analysis/:uid',
    component: ManageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'checkup',
    loadChildren: './modules/hwcheckup/hwcheckup.module#HwcheckupModule',
    canActivate: [AuthGuard]
  },
  {
    path: 'checkup/:iid',
    loadChildren: './modules/hwcheckup/hwcheckup.module#HwcheckupModule',
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'investor',
    component: InvestorDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    // path: 'investor2/:uid' , component : InvestorDetailsComponent, canActivate : [EditorGuard]
    path: 'manage-user',
    component: ManageUserComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'edituser/:uid',
    component: EditUserComponent,
    canActivate: [EditorGuard]
  },
  {
    path: 'fin-report/:uid',
    component: FinReportComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'suggestion-report/:uid',
    component: SuggestionReportComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'insurance-report/:uid',
    component: InsuranceReportComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'existing-user',
    component: ExistingUserComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'investors/:uid',
    component: ExistingUserInvestorsComponent,
    canActivate: [EditorGuard]
  },
  {
    path: 'edituser', component: EditUserComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'all-investors',
    component: ExistingUserInvestorsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'my-applications',
    component: ExistingUserInvestorsComponent,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    InvestorDetailsComponent,
    ManageUserComponent,
    EditUserComponent,
    ExistingUserComponent,
    ExistingUserInvestorsComponent,
    DropZoneDirective,
    FileSettingsComponent,
    AssetCatalogComponent,
    RangeFilterPipe,
    ItemMatchingPipe,
    AssetItemComponent,
    InvestorHistoryComponent,
    SuggestionHistoryComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    NoopAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    CoreModule,
    ReactiveFormsModule,
    FormsModule,
    AngularFireModule,
    HwcheckupModule,
    SharedModule,
    Ng5SliderModule,
    BrowserAnimationsModule,
  ],
  providers: [
    AssetService,
    CategoryDataService,
    InvestorDataService,
    AuthService,
    ManageUserService,
    AngularFireDatabase,
    ScorecardCalcService,
    CalcService,
    AssetTabComponent,
    SuperAdminGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts